import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleScroll = () => {
    // Mengecek lebar layar, dan hanya mengubah isHeaderActive jika layar lebih besar dari 576px
    if (window.innerWidth > 576) {
      if (window.scrollY > 0) {
        setIsHeaderActive(true);
      } else {
        setIsHeaderActive(false);
      }
    }
  };

  // Add event listener for scroll
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Apply the active class based on scroll position
  useEffect(() => {
    if (window.innerWidth > 576 && window.scrollY > 0) {
      setIsHeaderActive(true);
    }
  }, []);

  return (
    <>
      <header className={`header ${isHeaderActive ? 'active' : ''}`}>
        <a href="#" className="logo">
          <img src="assets/img/sanema-logo.ico"></img>
        </a>

        <nav className={`navbar ${isMenuOpen ? 'active' : ''}`}>
          <div
            id="nav-close"
            className="fas fa-times"
            onClick={toggleMenu}
          ></div>
          <NavLink to="/" activeClassName="active-link">
            Beranda
          </NavLink>
          <NavLink to="/About" activeClassName="active-link">
            Tentang Kami
          </NavLink>
          <NavLink to="/PaketPerjalanan" activeClassName="active-link">
            Paket Perjalanan
          </NavLink>
          <NavLink to="/Artikel" activeClassName="active-link">
            Artikel
          </NavLink>
          <NavLink to="/Contact" activeClassName="active-link">
            Kontak Kami
          </NavLink>
        </nav>

        <div className="icons">
          <div id="menu-btn" className="fas fa-bars" onClick={toggleMenu}></div>
        </div>
      </header>
    </>
  );
}

export default Header;
